/**
 * anchors.js
 *
 * @since 1.0.2
 */

'use strict';

/* global jQuery */
jQuery(function ($) {
  /**
   * Animate the anchor-scrolling
   *
   * @since 1.0.2
   * @var object targetElement  The target element
   * @var integer elementsTop   The top-position of the target element
   *                            including the height of the header
   */
  function processAclick(e) {
    var event = e;
    event.preventDefault();
    var targetElement = $('html').find(event.currentTarget.hash);
    var elementsTop = targetElement[0].offsetTop - 92;
    $('html, body').stop().animate({
      'scrollTop': elementsTop
    }, 900);
    return;
  }

  /**
  * Catching all anchor clicks after dociment is loaded
  *
  * @since 1.0.2
  */
  $(document).ready(function () {
    $('a[href^="#"]').on('click', processAclick);
  });
});